// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__tv57Z","footer":"ModalFilter_footer__310gX"};